import React from "react";

const CommonHeader = (props) => {
  return (
    <header id="head" className="secondary">
      <div className="container">
        <h1>{props.heading}</h1>
      </div>
    </header>
  );
};

export default CommonHeader;
